{
  "nl": {
    "backofficeHeader": {
      "exit": "Backoffice verlaten"
    }
  }
}
